import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const userCategorySelector = ({ userCategory }: ReducerState) => userCategory;
export const userCategoryLoadingSelector = createSelector(
  userCategorySelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
